import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { snackActions } from '../../SnackbarUtilsConfigurator'
import { PrinterResponse, StampaObj } from './stampeSlice'

export const stampeApi = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_ENDPOINT + '/stampe' }),
    reducerPath: 'stampeApi',
    refetchOnFocus: false,
    refetchOnReconnect: true,
    endpoints: (build) => ({
        getPrinters: build.query<PrinterResponse, void>({
            query: () => `printers`,
        }),
        postTemplateReportStampa: build.mutation<any, StampaObj>({
            query: (body) => ({
                url: `/templateReportStampa`,
                method: 'POST',
                body,
            }),
            //invalidatesTags: ['all'],
            transformResponse: (response: any) => {
                return response
            },
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetPrintersQuery, usePostTemplateReportStampaMutation } = stampeApi

// -------------------------------------------------------------------
// GENERIC METHOD STAMPE
// -------------------------------------------------------------------

export const stampe = (id: string, callback: (response: any) => void) => {
    const requestOptions = {
        method: 'GET',
        //headers: { 'Content-Type': 'application/pdf' },
        // body: JSON.stringify({
        //     id,
        // }),
    }
    fetch(`${process.env.REACT_APP_ENDPOINT}/stampe/by_id?id=1`, requestOptions)
        .then((response) => {
            return response.blob()
        })
        .then((blob: any) => {
            // var url = window.URL.createObjectURL(blob)
            // var newBlob = new Blob([blob])
            // callback(newBlob)
            //window.open(url);

            var url = window.URL.createObjectURL(blob)
            var a = document.createElement('a')
            a.href = url
            a.download = 'filename.pdf'
            document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click()
            a.remove()

            // console.log(data)
            // //var base64Str = Buffer.from(data, 'base64').toString('utf-8')
            // //callback(data)
            // const a = document.createElement('a')
            // const file = new Blob([data], { type: 'application/pdf' })
            // a.href = URL.createObjectURL(file)
            // a.download = 'pppppp.pdf'
            // a.click()
            // //  base64.base64Decode(base64Str, 'file.pdf')
        })
        .catch((error) => {
            snackActions.error(error.message)
        })
}
